import { ItemList } from '../orm'

class FaxItemList extends ItemList {
    getEntityKey() {
        return "fax_item"
    }
}

export const faxItemList = new FaxItemList("fax_item__default")
